import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/KREWE.svg'


const _withScopeId = n => (_pushScopeId("data-v-71f6e34b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = { class: "ion-text-center ion-padding-top" }
const _hoisted_4 = { class: "ion-text-uppercase" }
const _hoisted_5 = {
  key: 1,
  class: "ion-text-uppercase"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "sentence-case" }
const _hoisted_8 = {
  key: 2,
  class: "ion-text-center ion-padding-top"
}
const _hoisted_9 = {
  key: 1,
  class: "ion-text-center ion-padding-top"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_Image = _resolveComponent("Image")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            (Object.keys(_ctx.order).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isOrderUpdated)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("Order Confirmed")), 1),
                          _createVNode(_component_ion_icon, {
                            size: "large",
                            color: "success",
                            icon: _ctx.checkmarkCircle
                          }, null, 8, ["icon"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.isOrderCancelled)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t("Order Cancelled")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_ion_item, {
                    lines: "none",
                    class: "ion-text-center ion-margin-bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h1", null, _toDisplayString(_ctx.order.orderName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.getMessage())
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 0,
                        lines: "none",
                        class: "ion-margin-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "ion-text-center",
                            innerHTML: _ctx.getMessage()
                          }, null, 8, ["innerHTML"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, {
                        lines: "none",
                        class: "border"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.order.customerName) + " ", 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.order.id), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_note, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(_ctx.order.orderDate)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.order.statusId !== 'ORDER_CANCELLED' && _ctx.order.shipGroup.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.shipGroup, (shipGroup, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createVNode(_component_ion_card, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shipGroup.items, (item) => {
                                  return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                                    key: item.id,
                                    lines: "full"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Image, {
                                            src: _ctx.getProduct(item.productId).mainImageUrl
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_label, { slot: "start" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, _toDisplayString(item.brandName), 1),
                                          _createElementVNode("h2", null, _toDisplayString(item.name), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$filters.groupFeatures(_ctx.getProduct(item.productId).featureHierarchy)), (attribute, feature) => {
                                            return (_openBlock(), _createElementBlock("p", { key: attribute }, [
                                              _createElementVNode("span", _hoisted_7, _toDisplayString(feature), 1),
                                              _createTextVNode(": " + _toDisplayString(attribute), 1)
                                            ]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)), [
                                    [_vShow, item.status !== 'ITEM_CANCELLED']
                                  ])
                                }), 128)),
                                (!_ctx.isOrderCancelled)
                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                      key: 0,
                                      lines: "full"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { class: "ion-text-uppercase" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("Estimated Delivery")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_label, { slot: "end" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getTwoDeliveryDate()), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (shipGroup.trackingNumber)
                                  ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('Tracking code')), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_note, { slot: "end" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(shipGroup.trackingNumber), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            (!(_ctx.isOrderUpdated || _ctx.isOrderCancelled))
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  class: "primary-btn ion-margin-vertical",
                                  onClick: ($event: any) => (_ctx.updateShippingAddress(shipGroup)),
                                  expand: "block"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Ship it with two day delivery")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.hasPermission(_ctx.Actions.APP_SHPGRP_CNCL))
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 1,
                                  expand: "block",
                                  onClick: ($event: any) => (_ctx.cancel(shipGroup)),
                                  fill: "clear",
                                  color: "danger"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Cancel")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : (!(_ctx.isOrderCancelled || _ctx.isOrderUpdated))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("Order item not eligible for reroute fulfilment")), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                  (_ctx.isOrderCancelled || _ctx.isOrderUpdated || (_ctx.order.statusId === 'ORDER_CANCELLED' && _ctx.order.shipGroup.length <= 0))
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 3,
                        expand: "block",
                        class: "primary-btn ion-margin-vertical",
                        onClick: _ctx.redirectToStore
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("Continue shopping")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.loader == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Order not found")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}